module.exports = __webpack_public_path__ + "assets/images/familiar_disease_r.509358c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/familiar_disease_r.png
// module id = 707
// module chunks = 1